import { UploadedFile } from '../../../../types';

/**
 * The function `canSubmitStandard` determines if a standard submission can be made based on various
 * conditions.
 * @param {boolean} isRespondedStatus - A boolean value indicating whether the response status is
 * already responded or not.
 * @param {boolean} canSubmitIfLateResponse - A boolean value indicating whether the submission can be
 * made even if the response is late.
 * @param {number | undefined} responseTypeId - The `responseTypeId` parameter is a number or
 * undefined. It represents the type of response for a particular submission.
 * @param {boolean} responseTypeIdIsConsultedInError - A boolean value indicating whether the response
 * type ID is consulted in error.
 * @param {string | undefined} responseDetail - A string representing the response detail.
 * @param {UploadedFile[] | undefined} responseFiles - An array of uploaded files that are part of the
 * response.
 * @param {boolean | undefined} requiredFiles - A boolean value indicating whether the submission
 * requires files to be attached
 */
export const canSubmitStandard = (
  isRespondedStatus: boolean,
  canSubmitIfLateResponse: boolean,
  responseTypeId: number | undefined,
  responseTypeIdIsConsultedInError: boolean,
  responseDetail: string | undefined,
  responseFiles: UploadedFile[] | undefined,
  requiredFiles: boolean | undefined
): boolean =>
  canSubmitIfLateResponse &&
  !isRespondedStatus &&
  !!responseTypeId &&
  (!responseTypeIdIsConsultedInError || !!responseDetail) &&
  (requiredFiles ? !!responseFiles?.length : true);
